/**
 * AutoPlayVideo - Lazy autoplay video tile.
 *
 * Performance: was previously `preload="auto"` which forced the
 * browser to download the full file (3–5 MB) on mount, even off-
 * screen. Now `preload="metadata"` so only the moov atom (~few KB)
 * loads up-front; the rest streams as the muted video plays.
 *
 * Still uses useAlwaysPlayingVideo to recover from iOS Safari /
 * Capacitor WebView's "pause after 2 loops" bug.
 */
import React from 'react';
import useAlwaysPlayingVideo from '../../utils/useAlwaysPlayingVideo';

const AutoPlayVideo = ({ src, className, style }) => {
  const ref = useAlwaysPlayingVideo();

  return (
    <video
      ref={ref}
      src={src}
      className={className}
      style={style}
      autoPlay
      loop
      muted
      playsInline
      preload="metadata"
      onEnded={(e) => { try { e.currentTarget.currentTime = 0; e.currentTarget.play().catch(() => {}); } catch {} }}
      onError={(e) => { try { e.currentTarget.load(); e.currentTarget.play().catch(() => {}); } catch {} }}
    />
  );
};

export default AutoPlayVideo;
